// Outline variant of CalendarIcon.jsx — normalized to 24×24 / stroke 2

const CALENDAR_DAY_CELLS = [
  { x: 7.5, y: 11 },
  { x: 11.5, y: 11 },
  { x: 15.5, y: 11 },
  { x: 7.5, y: 15 },
  { x: 11.5, y: 15 },
  { x: 15.5, y: 15 },
];

const CalendarOutlineIcon = ({
  size = 24,
  color = "#14B8A6",
  strokeWidth = 2,
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect x="3" y="3" width="18" height="18" rx="2.4" stroke={color} strokeWidth={strokeWidth} />
      <path d="M3 8H21" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      <path d="M7.5 3V6.6" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      <path d="M16.5 3V6.6" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
      {CALENDAR_DAY_CELLS.map(({ x, y }) => (
        <rect
          key={`${x}-${y}`}
          x={x}
          y={y}
          width="1"
          height="1"
          rx="0.18"
          stroke={color}
          strokeWidth={strokeWidth}
        />
      ))}
    </svg>
  );
};

export default CalendarOutlineIcon;
